import React from "react";
import "./Footer.css";
import logo from "../assets/White_logo_tm_TB.png"; // use your logo path
import { MdEmail } from "react-icons/md"; 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left section: Logo + Description */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={logo} alt="Thryiv logo" className="footer-logo-img" />
          </div>
          <p className="footer-desc">
            The complete SaaS platform for HRMS, Payroll & Compliance — powered
            by FlexPros design language.
          </p>
        </div>

        {/* Right columns */}
        <div className="footer-links">
          {/* <div className="footer-column">
            <h3>Product</h3>
            <a href="#features">Features</a>
            <a href="#product">Product</a>
            <a href="#pricing">Pricing</a>
          </div>

          <div className="footer-column">
            <h3>Company</h3>
            <a href="#about">About</a>
            <a href="#careers">Careers</a>
            <a href="#blog">Blog</a>
          </div> */}

          <div className="footer-column">
  <h3>Contact Us</h3>
  <a href="mailto:support@flexpros.in" className="footer-email">
    <MdEmail className="email-icon" />
    support@thryiv.in
  </a>
</div>
        </div>

      </div>
      <div className="bottom">
      <p>© 2025 Swatsan Tech Pvt. Ltd. All rights reserved.</p>
      </div>
    </footer>
    
  );
};

export default Footer;
